import React, { useEffect, useState } from "react";
import { Grid, Modal } from "@material-ui/core";
import NavigateNextOutlinedIcon from "@material-ui/icons/NavigateNextOutlined";

const ProductModal = ({ open, onClose, onOpen,children,  }) => {
//   const handleClose = () => {
//     setIsOpen(false);
//   };

  return (
    <>
      <div className="open-modal-icon">
        <NavigateNextOutlinedIcon onClick={() => onOpen(true)} />
      </div>
      <Modal
        open={open}
        onClose={onClose}
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
        className="product-modal-wrap"
      >
        {children}
      </Modal>
      {/* <div className="product-modal-wrap"></div> */}
    </>
  );
};

export default ProductModal;
